module.exports = __webpack_public_path__ + "static/media/cataclyst-circle.4114722a.svg";